// Updated getFieldName function with better debugging
export const getFieldName = (field, index) => {
  
  const {
    name: field_name_from_api,
    labelName: field_label,
    label: field_label_alt
  } = field || {};

  // First check if API provides a name
  if (field_name_from_api) {
    return field_name_from_api;
  }
  
  const finalFieldLabel = field_label || field_label_alt;
  
  const labelMap = {
    'First Name': 'firstName',
    'Last Name': 'lastName',
    'Email': 'email',
    'Phone': 'phone',
    'Postal Code': 'postalCode',
    'Zip Code': 'postalCode',
    'T & C': 'tc',
    'Terms & Conditions': 'T & C',
    'Date of Birth': 'dob',
    'Gender': 'gender',
    'Address': 'address',
    'Street': 'street',
    'City': 'city',
    'State': 'state',
    'Country': 'country',
    'CURRENT pain level:': 'currentPainLevel',
    'WORST pain level:': 'worstPainLevel',
    'BEST pain level:': 'bestPainLevel',
    'Image': 'image',
    'Radio': 'gender', 
    'Text': 'text' 
  };
  
  if (finalFieldLabel && labelMap[finalFieldLabel]) {
    return labelMap[finalFieldLabel];
  }
  
  if (finalFieldLabel) {
    const generatedName = finalFieldLabel
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, ''); 
    return generatedName;
  }
  
  const fallbackName = `field_${index}`;
  return fallbackName;
};

